// 読み込みエラーをユーザーに分かりやすく提示するための型。
// message は日本語の説明、hint は「どうすればいいか」。

export class FmError extends Error {
  readonly where: string;
  readonly hint: string | undefined;

  constructor(where: string, message: string, hint?: string) {
    super(message);
    this.name = "FmError";
    this.where = where;
    this.hint = hint;
  }

  /** UI 表示用の整形文字列 */
  toDisplay(): { title: string; detail: string; hint: string | null } {
    return {
      title: `${this.where} の読み込みに失敗しました`,
      detail: this.message,
      hint: this.hint ?? null,
    };
  }
}

export function fail(where: string, message: string, hint?: string): never {
  throw new FmError(where, message, hint);
}

/** 条件が偽なら FmError を投げる */
export function ensure(cond: unknown, where: string, message: string, hint?: string): asserts cond {
  if (!cond) fail(where, message, hint);
}

export function describeError(e: unknown): { title: string; detail: string; hint: string | null } {
  if (e instanceof FmError) return e.toDisplay();
  if (e instanceof Error) {
    return { title: "エラーが発生しました", detail: e.message, hint: null };
  }
  return { title: "エラーが発生しました", detail: String(e), hint: null };
}
